/* eslint-disable max-len */
import React from 'react';

export default function AppUnavailableScreen() {
    return (
        <div className="flex">
            <div className="sm:flex-row flex-col relative flex h-custom w-full">
                <div className="sm:w-[50%] w-full sm:opacity-100 opacity-50">
                    <img src="images/falcon_login_image.jpg" alt="icon" className="h-custom w-full object-cover" />
                </div>
                <div className="sm:w-[50%] w-full flex justify-center items-center absolute sm:relative top-1/2 sm:top-0 -translate-y-1/2 sm:translate-y-0 sm:px-0 px-6">
                    <div className="max-w-[448px] w-full sm:p-0 p-6 bg-[#FFFFFF] sm:rounded-none rounded-lg text-center">
                        <h5 className="md:text-[26px] text-2xl font-bold text-[#090406] pb-4">
                            Application Temporarily Unavailable
                        </h5>
                        <p className="text-base font-normal text-[#555259] pb-4">
                            The system is currently under maintenance to deliver performance upgrades.
                            Please try again in a few moments.
                        </p>
                        <p className="text-base font-semibold text-[#ED1C24] pb-8">Thank you for your patience.</p>
                        <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="w-full md:h-[48px] h-10 bg-[#FF383C] hover:bg-[#ED1C24] rounded-lg text-base font-semibold text-[#FFFFFF]"
                        >
                            Refresh Page
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
